import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { ModalButton, ModalCancelButton } from 'components/modal-provider/modal';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { EProductField } from 'store/field-options/types';
import labels from 'constants/labels';
import colors from 'theme/colors';

export interface DeleteModalInterface {
  deleteProduct: Function;
  openDialog: boolean;
  handleDialogClose: () => void;
  chipValues: string;
  setChipValue: Function;
  name: string | undefined;
  updateProductField: Function;
  index: number;
}

const { darkPanelBackground, darkBackgroundLightBorder, white } = colors;

const StyledModal = withStyles({
  scrollPaper: {
    justifyContent: 'flex-start',
  },
  paperWidthSm: {
    background: `${darkPanelBackground}`,
    padding: '10px',
    margin: '23px',
  },
})(Dialog);

const ModalContentText = withStyles({
  root: {
    color: `${white}`,
    fontSize: '18px',
    textAlign: 'center',
  },
})(DialogContentText);

const ModalButtonContainer = withStyles({
  root: {
    borderTop: `1px solid ${darkBackgroundLightBorder}`,
    padding: '14px 8px',
  },
})(DialogActions);

export default ({
  openDialog,
  handleDialogClose,
  deleteProduct,
  chipValues,
  setChipValue,
  name,
  updateProductField,
  index,
}: DeleteModalInterface) => (
  <>
    <StyledModal
      open={openDialog}
      onClose={handleDialogClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <ModalContentText data-testid="dialog-test">Delete?</ModalContentText>
      </DialogContent>
      <ModalButtonContainer>
        <ModalCancelButton onClick={handleDialogClose}>{labels.button.cancel}</ModalCancelButton>
        <ModalButton
          onClick={() => {
            deleteProduct(chipValues);
            setChipValue('');
            handleDialogClose();
            if (name === chipValues) {
              updateProductField(index, EProductField.NAME, '');
            }
          }}
        >
          {labels.button.deleteConfirmation}
        </ModalButton>
      </ModalButtonContainer>
    </StyledModal>
  </>
);
